import { observer } from 'mobx-react';
import { ReactNode } from 'react';
interface FakeMasonryProps {
  width: number;
  minCellWidth?: number;
  maxColumnCount?: number;
  masonryCellGap?: number;
  cells: {
    orientation: 'horizontal' | 'vertical';
    children: ReactNode;
  }[];
}

function getColumnDetailsForMasonry(
  desiredWidth: number,
  minCellWidth: number,
  cellGap: number,
  maxColumnCount: number,
) {
  const columnCount = Math.min(Math.floor(desiredWidth / (minCellWidth + cellGap)), maxColumnCount);
  const columnWidth = (desiredWidth - (columnCount + 1) * cellGap) / columnCount;
  return { columnCount, columnWidth };
}

export const FakeMasonry = observer(function FakeMasonry({
  width: desiredWidth,
  minCellWidth = 290,
  maxColumnCount = 3,
  masonryCellGap = 10,
  cells,
}: FakeMasonryProps) {
  const { columnCount, columnWidth } = getColumnDetailsForMasonry(
    desiredWidth,
    minCellWidth,
    masonryCellGap,
    maxColumnCount,
  );

  const safeColumnWidth =
    columnWidth === Infinity || columnWidth === -Infinity ? 2000 : columnWidth;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columnCount}, ${safeColumnWidth}px)`,
        gap: masonryCellGap,
      }}
    >
      {cells.map((cell, index) => {
        const isHorizontal = cell.orientation === 'horizontal';
        return (
          <div
            key={`fake-masonry-item-${index}`}
            style={{
              width: safeColumnWidth,
              aspectRatio: isHorizontal ? 16 / 9 : 16 / 18,
              gridRow: isHorizontal ? 'span 1' : 'span 2',
              height: isHorizontal
                ? safeColumnWidth * (9 / 16) - masonryCellGap / 2
                : safeColumnWidth * (18 / 16),
              borderRadius: '14px',
              overflow: 'hidden',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {cell.children}
          </div>
        );
      })}
    </div>
  );
});
